// export const API_BASE_URL = "http://192.168.1.9:3700/api/v1";    
export const API_BASE_URL = "https://api-chennaiauctionproperty.webdadsprojects.com/api/v1";    
